export default __webpack_public_path__ + "static/media/004-cow.8ef02485.svg";